import { clsx } from 'clsx';
import { ComponentPropsWithRef } from 'react';
import { card, cardHoverable } from './card.css';

export const LayoutCard = function LayoutCard({
  ref,
  className,
  hoverable,
  ...rest
}: ComponentPropsWithRef<'div'> & {
  hoverable?: boolean;
}) {
  return (
    <div
      ref={ref}
      className={clsx(card, hoverable && cardHoverable, className)}
      {...rest}
    ></div>
  );
};
